var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-message"},[_c('h1',[_vm._v("Er is een fout opgetreden.")]),_vm._v(" "),_c('p',[_vm._v("Klik "),_c('nuxt-link',{attrs:{"to":"/","title":"Home"}},[_vm._v("hier")]),_vm._v(" om terug te keren naar de homepagina.")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }